import { render, staticRenderFns } from "./operation-board-ticket.vue?vue&type=template&id=072b13ef&scoped=true&"
import script from "./operation-board-ticket.vue?vue&type=script&lang=js&"
export * from "./operation-board-ticket.vue?vue&type=script&lang=js&"
import style0 from "./operation-board-ticket.vue?vue&type=style&index=0&id=072b13ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b13ef",
  null
  
)

export default component.exports